import React from 'react';
// images
import desktopImageDesktopWebp from './images/financial-information-hero-desktop.webp';
import desktopImageMobileWebp from './images/financial-information-hero-mobile.webp';
// low res images
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { FlexibleHeroStyled } from './styles';

export default () => {
  return (
    <FlexibleHeroStyled
      sectionId='financial-information-page-flexible-hero'
      headingText='Our commitment to financial strength'
      headingTextPosition='bottom'
      desktopImage={desktopImageDesktopWebp.toString()}
      mobileImage={desktopImageMobileWebp.toString()}
      desktopImageLowRes={lowResImageDesktop}
      mobileImageLowRes={lowResImageMobile}
    />
  );
};
